<template>
  <div>
    <div :style="`width: ${size}px; z-index:99; position:relative`">
      <div class="d-flex flex-row">
        <v-btn
          v-if="!noButtons"
          small
          icon
          rounded
          @click="btnClick(largeBtnChange)"
          color="primary"
          ><v-icon small>mdi-chevron-double-left</v-icon></v-btn
        >
        <v-btn
          v-if="!noButtons"
          small
          icon
          rounded
          @click="btnClick(smallBtnChange)"
          color="primary"
          ><v-icon small>mdi-chevron-left</v-icon></v-btn
        >
        <v-slider
          v-model="sliderVal"
          :min="min"
          :max="max"
          thumb-label="always"
          dense
          :hide-details="true"
          @start="dragging = true"
          @end="dragging = false"
          @touchstart="dragging = true"
          @touchend="dragging = false"
        >
          <template v-slot:thumb-label>{{ trueAxis }}</template>
        </v-slider>
        <v-btn
          v-if="!noButtons"
          small
          icon
          rounded
          @click="btnClick(-smallBtnChange)"
          color="primary"
          ><v-icon small>mdi-chevron-right</v-icon></v-btn
        >
        <v-btn
          v-if="!noButtons"
          small
          icon
          rounded
          @click="btnClick(-largeBtnChange)"
          color="primary"
          ><v-icon small>mdi-chevron-double-right</v-icon></v-btn
        >
      </div>
    </div>
  </div>
</template>

<script>
// import Name from "../dir/file";

export default {
  name: "RotateSlider",
  props: {
    min: { type: Number, default: 0 },
    max: { type: Number, default: 180 },
    // increments: { type: Number, default: 180 },
    steps: { type: Number, default: 1 },
    size: { type: Number, default: 400 },
    noButtons: { type: Boolean, default: false },
  },
  data: function () {
    return {
      sliderVal: 90,
      start: 90,
      dragging: false,
      largeBtnChange: 10,
      smallBtnChange: 1,
    };
  },
  methods: {
    btnClick(change) {
      this.sliderVal += change;
      this.emitChange();
    },

    emitChange() {
      //   if (newVal < 0) newVal = this.increments + newVal;
      //   if (newVal > this.increments) newVal = newVal - this.increments;
      // console.log(this.midVal, val, newVal);
      this.$emit("valChange", this.trueAxis);
    },
  },
  computed: {
    trueAxis: function () {
      return parseInt(180 - this.sliderVal);
    },
  },
  watch: {
    sliderVal() {
      if (this.dragging) {
        this.emitChange();
      }
    },
  },
  mounted() {},
};
</script>

<style scoped></style>
